import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import NotificationSystem from "react-notification-system";

import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";
import Sidebar from "components/Sidebar/Sidebar";
import Login from "components/Login/Login";
import PwaInstallPrompt from "components/PwaInstallPrompt/PwaInstallPrompt";
import PushNotificationPrompt from "components/PushNotificationPrompt/PushNotificationPrompt";

import { style } from "variables/Variables.jsx";
//import { Button } from "react-bootstrap";
import dashboardRoutes from "routes/dashboard.jsx";
import Charts from "views/Charts/Charts";
import UserProfile from "views/UserProfile/UserProfile";
import TableList from "views/TableList/TableList";
import Dashboard2 from "views/Dashboard/Dashboard2";
import {
  clearSessionToken,
  getSessionToken,
  setSessionToken
} from "utils/sessionStorage";

//import { truncate } from "fs";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handleNotificationClick = this.handleNotificationClick.bind(this);
    this.state = {
      _notificationSystem: null,
      user: null,
      userCredentials: null,
      adminCredentials: null,
      restoringSession: true
    };
  }

  handleNotificationClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift" />,
      message: (
        <div>
          Welcome to <b>Light Bootstrap Dashboard</b> - a beautiful freebie for
          every web developer.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15
    });
  }
  componentDidMount() {
    // this.setState({ _notificationSystem: this.refs.notificationSystem });
    // var _notificationSystem = this.refs.notificationSystem;
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    // _notificationSystem.addNotification({
    //   title: <span data-notify="icon" className="pe-7s-gift" />,
    //   message: (
    //     <div>
    //       Welcome to <b>Light Bootstrap Dashboard</b> - a beautiful freebie for
    //       every web developer.
    //     </div>
    //   ),
    //   level: level,
    //   position: "tr",
    //   autoDismiss: 15
    // });
    this.restoreSession();
  }
  restoreSession = () => {
    const token = getSessionToken();
    if (!token) {
      this.setState({ restoringSession: false });
      return;
    }
    fetch("https://hgsystem.pl/mangusta/login2.php", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ session_token: token })
    })
      .then(response =>
        response.json().then(data => {
          if (!response.ok || !data.user)
            throw new Error(data.error || "Session expired");
          this.handleLogin(data, { session_token: data.session_token || token });
        })
      )
      .catch(() => {
        clearSessionToken();
        this.setState({ restoringSession: false });
      });
  };

  onLogout = () => {
    const token = getSessionToken();
    if (token) {
      fetch("https://hgsystem.pl/mangusta/logout.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_token: token })
      }).catch(() => {});
    }
    clearSessionToken();
    this.setState({
      user: null,
      userCredentials: null,
      adminCredentials: null,
      restoringSession: false
    });
  };
  componentDidUpdate(previousProps) {
    const pathChanged =
      previousProps.location.pathname !== this.props.location.pathname;
    if (
      window.innerWidth < 993 &&
      pathChanged &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
    if (pathChanged) {
      document.documentElement.scrollTop = 0;
      if (document.scrollingElement)
        document.scrollingElement.scrollTop = 0;
      if (this.refs.mainPanel)
        this.refs.mainPanel.scrollTop = 0;
    }
  }

  handleLogin = (userData, credentials) => {
    userData.device = Array.isArray(userData.device) ? userData.device : [];
    userData.deviceSettings = userData.deviceSettings || {};
    userData.lastMeasurement = userData.lastMeasurement || {};
    userData.lastMessage = userData.lastMessage || {};
    userData.isAdmin = userData.isAdmin === true;
    if (userData.user.id === 6) {
      userData.device.forEach((device, key) => {
        device.desc = "Demo " + (key + 1);
      });
    }
    if (credentials && credentials.session_token)
      setSessionToken(credentials.session_token);
    this.setState({
      user: userData,
      userCredentials: credentials,
      adminCredentials: userData.isAdmin ? credentials : null,
      restoringSession: false
    });
  };

  handleDeviceSettingsChange = (deviceId, settings) => {
    this.setState(previousState => {
      if (!previousState.user) return null;
      return {
        user: {
          ...previousState.user,
          deviceSettings: {
            ...(previousState.user.deviceSettings || {}),
            [String(deviceId)]: settings
          }
        }
      };
    });
  };

  render() {
    console.log(this.state.user);
    const isAdministrator =
      this.state.user && this.state.user.isAdmin === true;
    return (
      <div className="wrapper">
        <PwaInstallPrompt />
        {this.state.user && (
          <div>
            <PushNotificationPrompt
              credentials={this.state.userCredentials}
            />
            <NotificationSystem ref="notificationSystem" style={style} />
            <Sidebar
              logout={this.onLogout}
              {...this.props}
              userData={this.state.user ? this.state.user.user : null}
              isAdmin={this.state.user.isAdmin}
            />
            <div id="main-panel" className="main-panel" ref="mainPanel">
              <Header
                logout={this.onLogout}
                {...this.props}
                userData={this.state.user ? this.state.user.user : null}
              />

              <Switch>
                {dashboardRoutes.map((prop, key) => {
                  //console.log(prop);

                  if (prop.adminOnly && !isAdministrator)
                    return null;
                  if (prop.name === "Notifications")
                    return (
                      <Route
                        exact
                        path={prop.path}
                        key={key}
                        render={routeProps => (
                          <prop.component
                            {...routeProps}
                            handleClick={this.handleNotificationClick}
                          />
                        )}
                      />
                    );
                  if (prop.path === "/dashboard")
                    return (
                      <Route
                        path={prop.path}
                        key={key}
                        render={props => (
                          <Dashboard2
                            device={this.state.user.device}
                            lastMeasurement={this.state.user.lastMeasurement}
                            lastMessage={this.state.user.lastMessage}
                            credentials={this.state.userCredentials}
                            {...props}
                          />
                        )}
                      />
                    );
                  if (prop.path === "/charts")
                    return (
                      <Route
                        path={prop.path}
                        key={key}
                        render={routeProps => (
                          <Charts
                            {...routeProps}
                            device={this.state.user.device}
                            deviceSettings={this.state.user.deviceSettings}
                            credentials={this.state.userCredentials}
                          />
                        )}
                      />
                    );
                  if (prop.path === "/collection-statistics")
                    return (
                      <Route
                        path={prop.path}
                        key={key}
                        render={routeProps => (
                          <prop.component
                            {...routeProps}
                            device={this.state.user.device}
                            credentials={this.state.userCredentials}
                          />
                        )}
                      />
                    );
                  if (prop.path === "/alarms")
                    return (
                      <Route
                        path={prop.path}
                        key={key}
                        render={routeProps => (
                          <prop.component
                            {...routeProps}
                            device={this.state.user.device}
                            credentials={this.state.userCredentials}
                          />
                        )}
                      />
                    );
                  if (prop.path === "/notifications")
                    return (
                      <Route
                        path={prop.path}
                        key={key}
                        render={routeProps => (
                          <prop.component
                            {...routeProps}
                            credentials={this.state.userCredentials}
                          />
                        )}
                      />
                    );
                  if (prop.path === "/table")
                    return (
                      <Route
                        path={prop.path}
                        key={key}
                        render={routeProps => (
                          <TableList
                            {...routeProps}
                            device={this.state.user.device}
                            deviceSettings={this.state.user.deviceSettings}
                            lastMeasurement={this.state.user.lastMeasurement}
                            lastMessage={this.state.user.lastMessage}
                            credentials={this.state.userCredentials}
                            isAdmin={isAdministrator}
                            onDeviceSettingsChange={
                              this.handleDeviceSettingsChange
                            }
                          />
                        )}
                      />
                    );
                  if (
                    prop.path === "/admin" ||
                    prop.path === "/statistics" ||
                    prop.path === "/firmware"
                  )
                    return (
                      <Route
                        exact
                        path={prop.path}
                        key={key}
                        render={routeProps => (
                          <prop.component
                            {...routeProps}
                            adminCredentials={this.state.adminCredentials}
                            onLogout={this.onLogout}
                          />
                        )}
                      />
                    );
                  if (prop.redirect)
                    return (
                      <Redirect
                        exact
                        from={prop.path}
                        to={prop.to}
                        key={key}
                      />
                    );
                  if (prop.path === "/user")
                    return (
                      <Route
                        path={prop.path}
                        key={key}
                        render={props => (
                          <UserProfile
                            userData={this.state.user.user}
                            {...props}
                          />
                        )}
                      />
                    );
                  else
                    return (
                      <Route
                        path={prop.path}
                        component={prop.component}
                        key={key}
                        user={this.state.user}
                      />
                    );
                })}
              </Switch>
              <Footer />
            </div>
          </div>
        )}
        {!this.state.user &&
          !this.state.restoringSession && (
            <Login onLogin={this.handleLogin} />
          )}
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx